export const makeUrlRelative = (url: string): string => {
  const ameriprisePattern =
    /^https:\/\/www[0-9a-zA-Z-]*(\.[a-zA-Z0-9-]+)?\.ameriprise\.com/

  // return original URL if the current host is not ameriprise.com
  const currentHost = window.location.href
  if (!ameriprisePattern.test(currentHost)) {
    return url
  }

  // convert URL to relative if it matches ameriprise.com pattern
  if (ameriprisePattern.test(url)) {
    const urlObj = new URL(url)
    return `${urlObj.pathname}${urlObj.search}${urlObj.hash}`
  }

  return url
}
